import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'walletAddressFormat',
  standalone: true
})
export class WalletAddressFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value || value.length < 12) return value; // In case of invalid or short address
     
    const firstPart = value.substring(0, 6);
    const lastPart = value.substring(value.length - 6);
     
    return `${firstPart}.....${lastPart}`;
  }

}
